import * as React from "react";
import { Form, TextArea as SegmentTexArea } from "semantic-ui-react";

export const TextArea = ({ name, label, error, ...rest }: any) => {
  return (
    <Form.Field
      error={
        error && {
          content: { error },
          pointing: "left",
        }
      }
    >
      <SegmentTexArea
        {...rest}
        name={name}
        id={name}
        style={{ height: "50px" }}
      />
    </Form.Field>
  );
};

export default TextArea;



// WEBPACK FOOTER //
// ./src/components/Form/textarea.tsx